import {
  StyledKeepCardButton,
  StyledRemoveCardConfirmButton,
  StyledRemoveCardModalContent,
  StyledRemoveCardModalDescription,
} from './styles';
import GenericModal from '@/components/uielements/genericModal';
import { StyledGenericModalFooter } from '@/components/uielements/genericModal/styles';
import { MODAL } from '@/constants/events';

interface RemoveCardModalProps {
  isOpen: boolean;
  cardType: string;
  cardSuffix: string;
  isLoading: boolean;
  onKeep: () => void;
  onRemove: () => void;
}

export const RemoveCardModal: React.FC<RemoveCardModalProps> = ({
  isOpen,
  cardType,
  cardSuffix,
  isLoading,
  onKeep,
  onRemove,
}) => {
  return (
    <GenericModal
      modalOpen={isOpen}
      name={MODAL.REMOVE_SAVED_CARD}
      title="Remove this card?"
      toggleModal={(show) => {
        if (!show) onKeep();
      }}
    >
      <StyledRemoveCardModalContent>
        <StyledRemoveCardModalDescription>
          <b>
            {cardType} •••• {cardSuffix}
          </b>{' '}
          will be removed from your account.
        </StyledRemoveCardModalDescription>
      </StyledRemoveCardModalContent>

      <StyledGenericModalFooter>
        <StyledKeepCardButton type="button" onClick={onKeep} disabled={isLoading}>
          Keep card
        </StyledKeepCardButton>
        <StyledRemoveCardConfirmButton type="button" onClick={onRemove} disabled={isLoading}>
          {isLoading ? 'Removing...' : 'Remove card'}
        </StyledRemoveCardConfirmButton>
      </StyledGenericModalFooter>
    </GenericModal>
  );
};
